import { v4 as uuidv4 } from 'uuid';
import { Uuid } from 'src/types/Id';

export function newUuid<T extends Uuid | undefined | null>(): T {
    return uuidv4() as T;
}
